export default function Services() {
  const services = [
    {
      icon: 'ri-brush-line',
      title: 'エアコン清掃',
      description: '業務用エアコンの内部まで徹底的に洗浄。カビや汚れを除去し、清潔な空気環境を実現します。',
      color: 'bg-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20deep%20cleaning%20of%20commercial%20air%20conditioning%20unit%20interior%2C%20technician%20using%20specialized%20cleaning%20equipment%20and%20solutions%2C%20white%20and%20blue%20clean%20environment%2C%20detailed%20maintenance%20work%2C%20high%20quality%20professional%20photography%2C%20spotless%20results&width=600&height=400&seq=service-clean-001&orientation=landscape'
    },
    {
      icon: 'ri-filter-3-line',
      title: 'フィルター交換',
      description: '定期的なフィルター交換で、エアコンの効率を維持。空気の質を保ち、電気代の削減にも貢献します。',
      color: 'bg-blue-500',
      image: 'https://readdy.ai/api/search-image?query=Technician%20replacing%20air%20conditioning%20filter%20in%20commercial%20unit%2C%20showing%20new%20clean%20filter%2C%20professional%20maintenance%20service%2C%20white%20and%20blue%20corporate%20environment%2C%20organized%20and%20efficient%20work%2C%20business%20photography%20style&width=600&height=400&seq=service-filter-001&orientation=landscape'
    },
    {
      icon: 'ri-search-eye-line',
      title: '定期点検',
      description: '専門スタッフによる定期的な点検で、故障を未然に防止。長期的な安定稼働をサポートします。',
      color: 'bg-indigo-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20inspecting%20commercial%20air%20conditioning%20system%20with%20diagnostic%20tools%2C%20checking%20performance%20and%20safety%2C%20modern%20office%20building%2C%20white%20and%20blue%20color%20scheme%2C%20thorough%20inspection%20process%2C%20professional%20service%20photography&width=600&height=400&seq=service-inspect-001&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: '修理サービス',
      description: '故障時の迅速な修理対応。豊富な経験と技術力で、あらゆるトラブルに対応いたします。',
      color: 'bg-slate-600',
      image: 'https://readdy.ai/api/search-image?query=Expert%20technician%20repairing%20commercial%20air%20conditioning%20unit%20with%20professional%20tools%2C%20fixing%20technical%20issues%2C%20clean%20corporate%20environment%20with%20white%20and%20blue%20tones%2C%20efficient%20repair%20work%2C%20high%20quality%20business%20photography&width=600&height=400&seq=service-repair-001&orientation=landscape'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'コンサルティング',
      description: '空調設備の最適化提案から、省エネ対策まで、専門的なアドバイスを提供します。',
      color: 'bg-lime-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20consultation%20meeting%20about%20air%20conditioning%20systems%2C%20consultant%20presenting%20energy%20efficiency%20plans%20with%20charts%20and%20documents%2C%20modern%20office%20conference%20room%2C%20white%20and%20blue%20corporate%20style%2C%20professional%20business%20photography&width=600&height=400&seq=service-consult-001&orientation=landscape'
    },
    {
      icon: 'ri-shopping-cart-line',
      title: '販売・リース',
      description: '最新の業務用エアコンの販売から、柔軟なリースプランまで、お客様のニーズに合わせたご提案をいたします。',
      color: 'bg-yellow-500',
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20air%20conditioning%20units%20display%20in%20showroom%2C%20various%20models%20available%20for%20sale%20and%20lease%2C%20professional%20business%20environment%2C%20white%20and%20blue%20color%20scheme%2C%20clean%20and%20organized%20presentation%2C%20business%20photography%20style&width=600&height=400&seq=service-sales-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            サービス内容
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            空調設備のトータルサポートで、快適な職場環境を実現
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white border border-slate-200 rounded-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                <div className={`absolute bottom-4 left-4 ${service.color} w-14 h-14 flex items-center justify-center rounded-lg shadow-lg`}>
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
